/** Regex patterns and field constraints for form validation. */

// Standard email shape. Keep the expression linear-time so untrusted input cannot
// trigger excessive regex backtracking; consecutive-special checks are performed below.
export const EMAIL_VALIDATION_REGEX =
  /^[a-zA-Z0-9][a-zA-Z0-9._-]*@[a-zA-Z0-9][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/;

export const isValidEmailFormat = (value: string): boolean => {
  if (!EMAIL_VALIDATION_REGEX.test(value)) {
    return false;
  }

  const [localPart, domainPart] = value.split("@");
  return !/[._-]{2}/.test(localPart) && !/[.-]{2}/.test(domainPart);
};

// NANP format: (NXX) NXX-XXXX
export const PHONE_VALIDATION_REGEX = /^\([2-9]\d{2}\) [2-9]\d{2}-\d{4}$/;

// Letters, digits, spaces, hyphens, apostrophes, and dots.
export const NAME_VALIDATION_REGEX = /^[a-zA-Z0-9][a-zA-Z0-9 .'-]*$/;

export const isValidNameFormat = (value: string): boolean => {
  if (!NAME_VALIDATION_REGEX.test(value)) {
    return false;
  }

  return !/[ .'-]{2}/.test(value) && /[a-zA-Z0-9.]$/.test(value);
};

export const MAX_PHONE_NUMBER_LENGTH = 14;
export const ONE_DAY_IN_MS = 86400000; // used to set DateInput maximumDate to yesterday

// ZIP code: 5-digit or 9-digit (xxxxx or xxxxx-xxxx)
export const ZIP_VALIDATION_REGEX = /^\d{5}(-\d{4})?$/;
export const ZIP_5_DIGIT_REGEX = /^\d{5}$/;
export const ZIP_9_DIGIT_REGEX = /^\d{5}-\d{4}$/;

/**
 * System-level validation error messages for GetStartedForm.
 * User-facing errors that reference "your" vs "the patient's" live in
 * src/constants/u18-labels.ts under getStartedForm.errorZip etc.
 */
export const GET_STARTED_FORM_ERRORS = {
  INSURANCE_PACKAGES_FAILED: "Failed to get insurance packages. Please try again",
  NO_COVERAGE_IN_AREA: "We currently do not serve this area.",
} as const;

/**
 * Shared between GetStartedForm and the Find Provider secondary filters —
 * both surface this when useReasonsForVisit's fetch fails.
 */
export const REASONS_FOR_VISIT_ERRORS = {
  FETCH_FAILED: "Failed to load reasons for visit. Please try again",
} as const;
